import { TESSearchField, TESSearchFields } from '../definitions';

export const polyneuroExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
   {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];
